<template>
  <PageContainer
    class="image-search"
    as-child
  >
    <PCBestdealerPublicity
      v-if="!isMobile"
      class="image-search__publicity"
    />
    <div class="image-search__wrapper">
      <PCHeader />
      <div class="image-search__content">
        <h2
          class="image-search__result"
          v-if="list.length"
        >
          Results for <span>"Similar items"</span>
        </h2>
        <Product
          :loading="loading"
          :product-list="list"
          @load="onLoad"
          @item-click="onItemClick"
        />
      </div>
    </div>
  </PageContainer>
</template>

<script setup>
import { Product } from '@/components/NewProduct'
import { useProductList } from './hooks/useProductList'
import { PageContainer } from '@/components/PageLayout'
import { buriedPointUtil, gaAnalytics, openURLWithChannelQuery } from '@/utils/utils'
import PCHeader from './components/PCHeader.vue'
import PCBestdealerPublicity from '@/components/BestdealerPublicity/PCBestdealerPublicity.vue'
import { isMobile } from '@/utils/constants'

const { loading, list, onLoad } = useProductList()

const onItemClick = (item) => {
  gaAnalytics('p_search_page_click', 'p_search_page_click', { spuId: item.offerId })
  buriedPointUtil({ eventId: 'PSC205', spuId: item.offerId })
  openURLWithChannelQuery(`/offer/${item.offerId}?key=${btoa(item.monthSold)}&adding=${btoa(item.addingCount)}`)
}
</script>

<style lang="less" scoped>
.image-search {
  display: flex;
  gap: 24px;

  &__publicity {
    padding: 24px 0;
    flex-shrink: 0;
  }

  &__wrapper {
    width: 100%;
  }

  &__content {
    padding: 32px 0;
  }

  &__result {
    color: #232323;
    font-family: mon-600;
    font-size: 20px;
    font-style: normal;
    line-height: 28px;
    letter-spacing: -0.4px;
    margin-bottom: 16px;

    > span {
      color: #052785;
      font-family: mon-700;
    }
  }
}
</style>
